export const gitCommit = '4f9bf6fe'
